import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";

export type AdminPageShellSize = "standard" | "wide";

interface AdminPageShellProps {
  breadcrumb: ReactNode;
  icon: LucideIcon;
  title: string;
  action?: ReactNode;
  children: ReactNode;
  size?: AdminPageShellSize;
  showIcon?: boolean;
}

export function AdminPageShell({
  breadcrumb,
  icon: Icon,
  title,
  action,
  children,
  size = "standard",
  showIcon = true,
}: AdminPageShellProps) {
  return (
    <div
      className={`operational-page-shell operational-page-shell--${size}`}
      data-page-size={size}
      data-testid="admin-page-shell"
    >
      <div style={{ marginBottom: "1rem" }}>{breadcrumb}</div>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "0.75rem",
          marginBottom: "1rem",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "0.85rem",
          }}
        >
          {showIcon ? (
            <div
              style={{
                width: "2.75rem",
                height: "2.75rem",
                borderRadius: "1rem",
                background:
                  "linear-gradient(180deg, color-mix(in srgb, var(--login-accent) 14%, transparent), color-mix(in srgb, var(--login-accent) 5%, transparent))",
                color: "var(--login-accent)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Icon size={18} />
            </div>
          ) : null}
          <div style={{ minWidth: 0 }}>
            <h1
              style={{
                margin: 0,
                fontFamily: "'Barlow Condensed', sans-serif",
                fontWeight: 700,
                fontSize: "1.65rem",
                letterSpacing: "0.04em",
                color: "var(--login-text)",
              }}
            >
              {title}
            </h1>
          </div>
        </div>
        {action}
      </div>

      {children}
    </div>
  );
}
